import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { InfoIcon as Info } from "@phosphor-icons/react";
import { track } from "@/lib/analytics";

/**
 * IosPurchaseNotice — shown in place of any Stripe "Buy" CTA inside the
 * native iOS shell (App Store guideline 3.1.1: no purchase paths for
 * digital items that aren't offered via In-App Purchase). Points users
 * at the subscription plans, which ARE purchasable via IAP.
 */
export default function IosPurchaseNotice({ label = "This purchase", showPlans = true, className = "" }) {
  useEffect(() => {
    track("ios_purchase_blocked_seen", { item: label });
  }, [label]);
  return (
    <div
      className={`rounded-xl border border-[#EAEAEA] bg-[#FAFAFA] p-4 text-[13px] text-[#3F3F3F] leading-relaxed ${className}`}
      data-testid="ios-purchase-notice"
    >
      <div className="flex items-start gap-2">
        <Info size={16} weight="duotone" className="text-[#8A6A00] mt-0.5 flex-shrink-0" />
        <div>
          <p>
            <strong>{label}</strong> isn&rsquo;t available in the app.
          </p>
          {showPlans && (
            <p className="mt-1">
              Subscription plans include registrations, listings, and more —{" "}
              <Link
                to="/account/subscription"
                onClick={() => track("ios_purchase_blocked_plans_click", { item: label })}
                className="font-semibold underline underline-offset-2"
                data-testid="ios-notice-plans-link"
              >
                see plans
              </Link>
              .
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
